import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import "../styles/pages/FishingSchool.css";


export default function FishingSchool() {
  const { t } = useTranslation();
  const [lessons, setLessons] = useState([]);
  const [search, setSearch] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  useEffect(() => {
    fetch("/data/FishingSchool/FishingSchool.md")
      .then((res) => res.text())
      .then((text) => parseMarkdown(text));
  }, []);

  // ---------------------------------------------------
  // ---------------------------------------------------
// PARSE MARKDOWN INTO LESSON OBJECTS
// ---------------------------------------------------
const parseMarkdown = (md) => {
  // Split by lesson titles "## ...", skip header block
  const blocks = md.split(/\n(?=## )/).slice(1);

  const parsed = blocks.map((block) => {
    const lines = block.split("\n");

    // Title line
    const rawTitle = lines[0] || "";
    const titleLine = rawTitle.replace(/^##\s*/, "").trim();

    // Find diagram heading
    const diagramIndex = lines.findIndex((l) =>
      l.toLowerCase().includes("ðŸ“¸") ||
      l.toLowerCase().includes("diagram")
    );

    let diagramUrl = null;
    if (diagramIndex !== -1) {
      const imgLine = lines[diagramIndex + 1] || "";
      const imgMatch = imgLine.match(/\((.*?)\)/);
      if (imgMatch) {
        diagramUrl = imgMatch[1];
      }
    }

    // ==============================================
    // CLEAN BODY LINES (THIS IS WHERE YOUR BLOCK GOES)
    // ==============================================
    const cleanedLines = lines.filter((line, idx) => {
      const lower = line.toLowerCase().trim();

      // Remove lesson title, diagram title, image line
      if (idx === 0) return false;
      if (idx === diagramIndex) return false;
      if (idx === diagramIndex + 1) return false;

      // Remove markdown separators
      if (lower === "---") return false;
      if (lower === "----") return false;

      // Remove farewell text
      if (lower.includes("happy learning")) return false;
      if (lower.includes("more lessons coming soon")) return false;

      return true;
    });

    // Remove any remaining image markdown or diagram mentions
    const textLines = cleanedLines.filter((line) => {
      if (line.toLowerCase().includes("diagram")) return false;
      if (/!\[.*?\]\(.*?\)/.test(line)) return false;
      return true;
    });

    const body = textLines.join("\n").trim();

    // RETURN PARSED LESSON
    return {
      id: titleLine.toLowerCase(),
      title: titleLine,
      body,
      diagram: diagramUrl,
    };
  });

  setLessons(parsed);
};

  // ---------------------------------------------------
  // SEARCH (ONLY LESSON TITLES)
  // ---------------------------------------------------
  const handleSearch = (e) => {
    const q = e.target.value.toLowerCase();
    setSearch(e.target.value);

    if (!q.trim()) {
      setSuggestions([]);
      return;
    }

    const results = lessons.filter((l) =>
      l.title.toLowerCase().includes(q)
    );

    setSuggestions(results);
  };

  return (
    <div className="school-page">
      {/* Back button */}
      

      {/* Page title (we can keep it static here) */}
      <h1>{t("school_title")}</h1>

      {/* SEARCH */}
      <div className="search-wrapper">
        <input
          className="lesson-search"
          placeholder={t("school_search_placeholder")}
          value={search}
          onChange={handleSearch}
        />

        {suggestions.length > 0 && (
          <div className="autocomplete-box">
            {suggestions.map((l) => (
              <div
                key={l.id}
                className="autocomplete-item"
                onClick={() => {
                  setSearch("");
                  setSuggestions([]);
                  const el = document.getElementById(l.id);
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
              >
                {l.title}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* LESSONS */}
      {lessons.map((l, index) => (
  <React.Fragment key={l.id}>
    <div id={l.id} className="lesson-block">
      <div className="lesson-top-row">
        <h2>{l.title}</h2>
      </div>

      <div className="lesson-columns">
        <div className="lesson-left">
          <ReactMarkdown>{l.body}</ReactMarkdown>
        </div>

        <div className="lesson-right">
          {l.diagram && (
            <img
              src={l.diagram}
              alt={t("school_diagram_alt", { defaultValue: "diagram" })}
              className="lesson-diagram-image"
            />
          )}
        </div>
      </div>
    </div>

    {/* ---- LESSON SEPARATOR ---- */}
    {index < lessons.length - 1 && <hr className="lesson-separator" />}
  </React.Fragment>
))}

    </div>
  );
}
